import React from 'react';
import { Empty, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import _AreaChart from 'codeArt/components/chart/AreaChart';
import { DashedPanel } from 'codeArt/components/accessory';
import _DonutChart from 'codeArt/components/chart/DonutChart';
import _BarChart from 'codeArt/components/chart/BarChart';
import _ScatterChart from 'codeArt/components/chart/ScatterChart';
import { Util, runtime } from 'codeArt/common';
import ModuleSide from 'codeArt/components/ModuleSide';
import { Shifts, Teams, Devices } from 'app/constant';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import AirplayIcon from '@material-ui/icons/Airplay';
import { Card1 } from 'codeArt/components/accessory/card';
import { StatisticsBar } from './device/StatisticsBar';
import { Grid, GridCell, GridSection } from 'codeArt/components/Layout';
import Switch from 'codeArt/components/input/Switch';

export function getRandom(min, max) {
  parseInt(Math.random() * (max - min + 1) + min, 10);
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export const RightPortalItemProps = {
  titleLine: true,
  titleClassName: "c-text-s3",
  headerClassName: "c-p-0",
  bodyClassName: "c-py-3 c-px-0",
  className: "c-py-3d5 c-px-4 my-2"
}

export function rightTipSelect(tip, className) {
  className = className || '';
  return <Portal full={true} className={`c-flex-1 ${className}`} bodyClassName="justify-content-center">
    <Empty text={tip} textClassName="c-text-s6" />
  </Portal>;
}

export function rightTipSelectRimless(tip, className) {
  return <div className={`d-flex h-100 w-100 justify-content-center align-items-center ${className}`}>
    <Empty text={tip} textClassName="c-text-s6" />
  </div>;
}


export function subtitle(title, className) {
  return <p className={`mb-0 c-text-s3 text-dark mt-3 ${className || ''}`}>{title}</p>;
}


export const ChartYHanle = {
  numerical: 1,
  float: 2,
  ratio: 3,
  ratio100: 4,
}


function getMinMAX(data) {
  let max = 0; let min = 1000000;
  data.forEach((t) => {
    if (t > max) max = t;
    if (t < min) min = t;
  });

  return { min, max };
}

const numericalHanle = (data) => {
  let { min, max } = getMinMAX(data);

  min = min - parseInt(min / 5);
  max = max + parseInt(max / 5);
  let interval = (max - min) / 5;
  return { format: (v) => { return (v == min || (v + 0.001) >= max) ? parseInt(v) : "" }, min: min, max: max, interval: interval };
}

const floatHanle = (data, format) => {
  let { min, max } = getMinMAX(data);

  min = min - parseFloat((min / 5).toFixed(2));
  max = max + parseFloat((max / 5).toFixed(2));
  let interval = (max - min) / 5;
  return { format: format ? (v) => { return format(v, min, max, interval); } : (v) => { return (v == min || (v + 0.001) >= max) ? `${v.toFixed(2)}` : "" }, min: min, max: max, interval: interval };
}

const ratioHanle = (data) => {
  return floatHanle(data, (v, min, max, interval) => { return (v == min || (v + 0.001) >= max) ? `${v.toFixed(2)}%` : ""; });
}

const ratio100Hanle = (data) => {
  let { min, max } = getMinMAX(data);
  min = min - parseFloat((min / 5).toFixed(2));
  max = 1;
  let interval = (max - min) / 5;
  return { min: min, max: max, interval: interval, format: (v) => { return (v == min || (v + 0.001) >= max) ? `${parseInt((v * 100).toFixed(2))}%` : ""; } };
}

const yHandls = {
  1: numericalHanle,
  2: floatHanle,
  3: ratioHanle,
  4: ratio100Hanle,
}

export class AreaChart extends React.Component {

  constructor(props) {
    super(props);
  }

  getY() {
    let handle = this.yHanle;
    if (handle) {
      let p = yHandls[handle](this.props.data);
      return { name: this.yName, ...p };
    }
  }


  getX() {
    return ["8:00", "9:00", "10:00", "11:00"];
  }

  getGrid() {

  }

  getMarkArea() {
    let data = this.getMarkData();
    if (!data) return;

    //{start,end}

    if (data.handle) {
      if (data.handle === "last") {
        let x = this.getX();
        data = { start: x[x.length - 2], end: x[x.length - 1] };
      }
    }

    let markArea = {
      itemStyle: {
        color: theme.color['light-grey']
      },
      data: [[{
        xAxis: data.start
      }, {
        xAxis: data.end
      }]]
    }

    return markArea;
  }

  getAxis() {

  }

  getData() {
    return { x: ["8:00", "9:00", "10:00", "11:00"] };
  }

  getMarkData() {

  }

  render() {
    let { data } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel title={this.title} empty={"不适用"} line={empty}>
        {empty ? null : <_AreaChart data={{
          y: [{ name: this.unit, color: theme.color.blue, data: data }], x: this.getX()
        }}
          area={false} legend={false} smooth={true}
          markArea={this.getMarkArea()}
          grid={{ left: '30', right: '10', top: "15", bottom: "0", containLabel: true, ...this.getGrid() }}
          y={{
            nameLocation: "center", nameGap: 32, min: 0, max: 500, interval: 100,
            axisLine: { "show": true }, axisTick: { "show": true }
            , ...this.getY()
          }} />}
      </DashedPanel>
    );
  }
}

export class DonutChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {
    let { title } = this.state;
    let { data, label } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel className="h-100" title={title || this.title || label} empty={"不适用"} line={empty}>
        {empty ? null : <_DonutChart data={data} label={label} />}
      </DashedPanel>
    );
  }
}

export class BarChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }


  getY() {

  }

  getX() {

  }

  getGrid() {

  }

  render() {
    let { title } = this.state;
    let { data, label, horizontal } = this.props;

    let empty = data ? false : true;
    return (
      <DashedPanel title={title || this.title || label} empty={"不适用"} line={empty}>
        {empty ? null : <_BarChart horizontal={horizontal} data={data} label={true} line={false} grid={{ left: 0, right: 0, bottom: 0, top: 50, ...this.getGrid() }} x={{ axisLine: { "show": true }, axisTick: { "show": true }, ...this.getX() }} y={{ axisLine: { "show": true }, axisTick: { "show": true }, min: 0, max: 5000, interval: 5000, ...this.getY() }} />}
      </DashedPanel>
    );
  }
}

export function chartItem({ name, value, unit, chart }) {
  const nameClassName = runtime.mobile? "c-text-s1" : "c-text-s3";
  const valueClassName = runtime.mobile? "c-text-s2" : "c-text-s4";
  const unitClassName = runtime.mobile? "c-text-s1" : "c-text-s1d5";
  return (
    <div className="col-sm-12 col-md-6 my-3">
      <div className="d-flex flex-column">
        <div className="d-flex flex-row justify-content-between align-items-end c-lb c-pb-2d5 mb-2">
          <p className={`mb-0 text-dark ${nameClassName} c-lh-1`}>{name}</p>
          <p className="mb-0 c-text-s1d5  c-lh-1">
            <span className={`${valueClassName} c-lh-1`}>{value}</span>
            {unit ? <span className={`pl-1 ${unitClassName} c-lh-1`}>{unit}</span> : null}
          </p>
        </div>
        <div className="d-flex flex-row justify-content-between align-items-center c-h-250px">
          {chart}
        </div>
      </div>
    </div>
  );
}

export function renderParam({ label, labelWidth, value, size }) {
  size = size || 'c-text-1d5';
  labelWidth = labelWidth || 130;
  return (
    <div className="d-flex flex-row justify-content-between justify-content-lg-center align-items-center my-1">
      <p className={`text-muted ${size} mb-0`} style={{ width: labelWidth }}>{label}</p>
      <p className={`text-muted ${size} mb-0`}>{value}</p>
    </div>
  );
}

export function renderCard({ color, icon, title, value, value0, value1, empty, className }) {
  const value0ClassName = runtime.mobile? "c-text-s2" : "c-text-s4";
  const value1ClassName = runtime.mobile? "c-text-s1" : "c-text-s2";
  let content = Util.invalid(value) ?
    [<p key={1} className={`mb-0 ${value0ClassName} c-lh-1`}>{value0}</p>,
    <p key={2} className={`mb-0 ${value1ClassName} c-lh-1 ml-1`}>/ {value1}</p>]
    :
    <p key={1} className={`mb-0 ${value0ClassName} c-lh-1`}>{value}</p>;
  return (
    <Card1 color={color} icon={icon} title={title} className={className} childrenClassName={empty ? "c-mb-0d5" : ""}>
      {empty ? empty : content}
    </Card1>
  );
}


export const FlatPortalProps = {
  flat: true,
  className: "c-p-0 c-mt-0",
  headerClassName: "c-p-0",
  bodyClassName: "c-p-0"
}

export function secondsTohms(s) {

  var sTime = parseInt(s);// 秒
  var mTime = 0;// 分
  var hTime = 0;// 时
  if (sTime > 60) {//如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    mTime = parseInt(sTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    sTime = parseInt(sTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (mTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hTime = parseInt(mTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      mTime = parseInt(mTime % 60);
    }
  }
  var result = '';
  if (sTime >= 0 && sTime < 10) {
    result = "0" + parseInt(sTime) + "";
  } else {
    result = "" + parseInt(sTime) + "";
  }
  if (mTime >= 0 && mTime < 10) {
    result = "0" + parseInt(mTime) + ":" + result;
  } else {
    result = "" + parseInt(mTime) + ":" + result;
  }
  if (hTime >= 0 && hTime < 10) {
    result = "0" + parseInt(hTime) + ":" + result;
  } else {
    result = "" + parseInt(hTime) + ":" + result;
  }
  return result;
}


export class Panel extends React.Component {

  constructor(props) {
    super(props);
  }

  onChange(v) {

  }

  handleChange(devices, item, selected, handleChange) {
    let items = devices;
    if (selected) {
      items.push(item);
    } else {
      Util.remove(items, (t) => {
        return t.id == item.id;
      });

    }
    handleChange("devices", items);
  }

  filter({ value, handleChange }) {
    if (!value.devices) {
      value.devices = [];
    }
    return (
      <div className="col-12">
        <Grid className="c-my-0">
          <GridSection className="mt-2 mb-1" textClassName={"c-text-s2"} title={"设备"} />
          {Devices.map((t, i) => {
            let selected = Util.first(value.devices, (c) => c.id == t.Id) ? true : false;
            return <CheckItem key={`${i}`} item={{ id: t.Id, name: t.Name }} selected={selected} onChange={({ item, selected }) => { this.handleChange(value.devices, item, selected, handleChange); }} />
          })}
        </Grid>
      </div>
    );
  }


  render() {
    return (
      <Portal full={true} scrollable={true} flat={true}>
        <div className="d-flex flex-column px-3">
          {this.props.children}
        </div>
        <StatisticsBar
          filter={this.filter.bind(this)}
          onChange={v => {
            this.onChange(v);
          }}
        />
      </Portal>
    )
  }

}


export class CheckItem extends React.Component {

  constructor(props) {
    super(props);
  }

  onChange(v) {
    let { item, onChange } = this.props;
    if (onChange) onChange({ item, selected: v });
  }

  render() {
    let { selected, number, item } = this.props;
    return (
      <GridCell className="c-pt-1" size={6} layout={"between"} label={item.name}
        content={<Switch className="c-mb-0" color="green" size="small" depend={{ value: selected ? 1 : 0 }} onClick={(v) => { this.onChange(v); }} />} labelClassName={`c-text-s2 ${selected ? 'm-text-dark75' : ''}`}
      />
    );
  }
}

export const gridCellSize = { xl: 4, lg: 6, sm: 12 };

export const stickType = {
  burst: { name: "爆珠棒", id: 1 },
  through: { name: "高透棒", id: 2 },
  hollow: { name: "中空拉丝棒", id: 3 },
  duality: { name: "二元复合棒", id: 4 },
  ternary: { name: "三元复合棒", id: 5 },
  quaternary: { name: "四元复合棒", id: 6 },
}


export const stickTypes = [
  { text: stickType.burst.name, value: stickType.burst.id },
  { text: stickType.through.name, value: stickType.through.id },
  { text: stickType.hollow.name, value: stickType.hollow.id },
  { text: stickType.duality.name, value: stickType.duality.id },
  { text: stickType.ternary.name, value: stickType.ternary.id },
  { text: stickType.quaternary.name, value: stickType.quaternary.id },
]